import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");

    const run = async () => {
      try {
        const referral_code = localStorage.getItem("referral_code") || null;
        const { data } = await api.post("/auth/session", { session_id: sessionId, referral_code });
        localStorage.removeItem("referral_code");
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: data } });
      } catch (e) {
        navigate("/");
      }
    };
    if (sessionId) run();
    else navigate("/");
  }, [navigate, setUser]);

  return (
    <div className="h-screen flex items-center justify-center bg-background text-foreground">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="w-6 h-6 animate-spin text-[#002FA7]" />
        <p className="text-xs uppercase tracking-[0.2em] text-neutral-500">Iniciando sesión…</p>
      </div>
    </div>
  );
}
